export default "__VITE_ASSET__Cl8lgKQT__"